import dayjs from "dayjs";

import { useTheme } from "@mui/material/styles";
import { Grid, TextField, useMediaQuery } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

import { useAuth } from "src/hooks/useAuth";
import { useDialog } from "src/context/DialogContext";
import { convertIntToCurrency } from "src/common";

import Button from "src/components/core/Button";
import {
  Column,
  Condition,
  Desc,
  GridColumn,
  GridRow,
  ImageEmpty,
  Payment,
  PdImage,
  SubColumn,
  Table,
  TextSubTable,
  TextTable,
  Title,
  WrapperProductList,
} from "src/modules/order/shipping-order/components";
import PreviewSlip from "src/modules/order/shipping-order/modal/PreviewSlip";

const PurchaseInfo = ({ info }) => {
  const { user, checkAllowPermission } = useAuth();
  const { openDialog, closeDialog } = useDialog();

  const isAdmin = user?.role_id === 1;
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm")); // mobile screens
  const isLg = useMediaQuery(theme.breakpoints.down("lg")); // mobile screens
  const rows = isAdmin
    ? isSm
      ? 4
      : isLg
        ? 9.5
        : 10.5
    : isSm
      ? 4
      : isLg
        ? 8.3
        : 9.5;

  // const adminList = [
  //   "ast.md@xsurface.com",
  //   "bd@xsurface.com",
  //   "service@xsurface.com",
  //   "accountadmin@xsurface.com",
  //   "webdev@xsurface.com",
  // ];

  if (info === undefined) return;
  return (
    <Grid container>
      <Grid item xs={12}>
        <Title>ข้อมูลสินค้า</Title>
      </Grid>

      <Grid item xs={12} sx={{ mt: { xs: 1 } }} mb={2}>
        <Desc>{`ร้านค้า ${info?.sellerName}`}</Desc>
      </Grid>

      <Table container>
        <WrapperProductList>
          {isAdmin ? (
            <GridColumn container>
              <Column
                item
                // xs={adminList.includes(user?.email) ? 4.7 : 6.05}
                // lg={adminList.includes(user?.email) ? 5.7 : 6.95}
                {...(checkAllowPermission("products.can_view_costPrice")
                  ? { lg: 5.7, xs: 4.7 }
                  : { lg: 6.95, xs: 6.05 })}
                display="flex"
                alignItems="center"
                sx={{
                  px: { xs: 1, md: 1, lg: 2 },
                }}
              >
                สินค้า
              </Column>
              {checkAllowPermission("products.can_view_costPrice") && (
                <Column
                  item
                  xs={1.35}
                  lg={1.25}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  ราคาต้นทุน
                </Column>
              )}
              <Column
                item
                xs={2}
                lg={1.35}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                ราคาขายต่อหน่วย
              </Column>
              <Column
                item
                xs={1.25}
                lg={1.24}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                จำนวน
              </Column>
              <Column
                item
                xs={1.3}
                lg={1.2}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                ส่วนลด
              </Column>
              <Column
                item
                xs={1.4}
                lg={1.26}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                ราคารวม
              </Column>
            </GridColumn>
          ) : (
            <GridColumn container>
              <Column
                item
                // xs={6.3}
                // lg={7}
                xs={10}
                display="flex"
                alignItems="center"
                sx={{
                  px: { xs: 1, md: 1, lg: 2 },
                }}
              >
                สินค้า
              </Column>

              {/* <Column
                item
                xs={2}
                // lg={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                ราคาต้นทุน
              </Column> */}

              <Column
                item
                // xs={1.4}
                // lg={1.25}
                xs={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                จำนวน
              </Column>

              {/* <Column
                item
                xs={2.3}
                lg={1.75}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                ราคารวม
              </Column> */}
            </GridColumn>
          )}

          {Object.keys(info).length > 0 &&
            info?.productChoiceOrders?.map((order, index) => (
              <GridRow container key={index}>
                {isAdmin ? (
                  <>
                    <SubColumn
                      item
                      // xs={adminList.includes(user?.email) ? 4.7 : 6.05}
                      // lg={adminList.includes(user?.email) ? 5.7 : 6.95}
                      {...(checkAllowPermission("products.can_view_costPrice")
                        ? { lg: 5.7, xs: 4.7 }
                        : { lg: 6.95, xs: 6.05 })}
                      display="flex"
                      alignItems="center"
                    >
                      <Grid item xs={2.5} sm={2} display="flex">
                        {!!order?.groupImage?.productDisplayImage ? (
                          <PdImage
                            src={order?.groupImage?.productDisplayImage}
                          />
                        ) : (
                          <ImageEmpty>
                            <InsertPhotoIcon
                              sx={{
                                color: "rgba(0, 0, 0, 0.54)",
                                cursor: "pointer",
                              }}
                            />
                          </ImageEmpty>
                        )}
                      </Grid>

                      <Grid container xs={9.5} sm={10} pl={3} display="flex">
                        <Grid item xs={12}>
                          <TextTable>
                            {order?.productChoiceOrder?.product?.item_name}
                          </TextTable>

                          <TextSubTable>
                            {order?.productChoiceOrder?.product?.item_code}
                          </TextSubTable>

                          {order?.productChoiceOrder?.color?.color_th &&
                          order?.productChoiceOrder?.texture_type?.type_th ? (
                            <TextSubTable>{`${order?.productChoiceOrder?.color?.color_th}_${order?.productChoiceOrder?.texture_type?.type_th}`}</TextSubTable>
                          ) : (
                            <TextSubTable>-</TextSubTable>
                          )}
                        </Grid>
                      </Grid>
                    </SubColumn>
                    {checkAllowPermission("products.can_view_costPrice") && (
                      <SubColumn
                        item
                        xs={1.35}
                        lg={1.25}
                        display="flex"
                        justifyContent="center"
                      >
                        <TextTable textAlign="center">
                          {convertIntToCurrency(
                            order?.costPrice ?? order?.price,
                          )}
                        </TextTable>
                      </SubColumn>
                    )}
                    <SubColumn
                      item
                      xs={2}
                      lg={1.35}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">
                        {convertIntToCurrency(order?.price)}
                      </TextTable>
                    </SubColumn>

                    <SubColumn
                      item
                      xs={1.25}
                      lg={1.24}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">{order?.volume}</TextTable>
                    </SubColumn>

                    <SubColumn
                      item
                      xs={1.3}
                      lg={1.2}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">
                        {order?.discount
                          ? convertIntToCurrency(order?.discount)
                          : "-"}
                      </TextTable>
                    </SubColumn>

                    <SubColumn
                      item
                      xs={1.4}
                      lg={1.26}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">
                        {convertIntToCurrency(order?.total)}
                      </TextTable>
                    </SubColumn>
                  </>
                ) : (
                  <>
                    <SubColumn
                      item
                      // xs={6.3}
                      // lg={7}
                      xs={10}
                      display="flex"
                      alignItems="center"
                    >
                      <Grid item xs={2.5} sm={2} display="flex">
                        <PdImage src={order?.groupImage?.productDisplayImage} />
                      </Grid>

                      <Grid container xs={9.5} sm={10} pl={3} display="flex">
                        <Grid item xs={12}>
                          <TextTable>
                            {order?.productChoiceOrder?.product?.item_name}
                          </TextTable>

                          <TextSubTable>
                            {order?.productChoiceOrder?.product?.item_code}
                          </TextSubTable>

                          {order?.productChoiceOrder?.color?.color_th &&
                          order?.productChoiceOrder?.texture_type?.type_th ? (
                            <TextSubTable>{`${order?.productChoiceOrder?.color?.color_th}_${order?.productChoiceOrder?.texture_type?.type_th}`}</TextSubTable>
                          ) : (
                            <TextSubTable>-</TextSubTable>
                          )}
                        </Grid>
                      </Grid>
                    </SubColumn>

                    {/* <SubColumn
                      item
                      xs={2}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">
                        {convertIntToCurrency(order?.costPrice ?? order?.price)}
                      </TextTable>
                    </SubColumn> */}

                    <SubColumn
                      item
                      // xs={1.4}
                      // lg={1.25}
                      xs={2}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">{order?.volume}</TextTable>
                    </SubColumn>

                    {/* <SubColumn
                      item
                      xs={2.3}
                      lg={1.75}
                      display="flex"
                      justifyContent="center"
                    >
                      <TextTable textAlign="center">
                        {convertIntToCurrency(
                          order?.costPrice
                            ? order?.costPrice * order?.volume
                            : order?.total,
                        )}
                      </TextTable>
                    </SubColumn> */}
                  </>
                )}
              </GridRow>
            ))}
        </WrapperProductList>
      </Table>

      {isAdmin && (
        <Condition isAdmin>
          <Grid container>
            <Grid item xs={12} sm={6} lg={6} sx={{ pr: { xs: 0, sm: 3 } }}>
              <Grid item xs={12}>
                <Title>เงื่อนไขสินค้า</Title>
              </Grid>

              <Grid item xs={12} mt={1}>
                <TextField
                  fullWidth
                  rows={rows}
                  multiline
                  disabled
                  sx={{
                    // Target the root input container when disabled
                    "& .MuiInputBase-root.Mui-disabled": {
                      backgroundColor: "#F3F1F2",
                      border: "1px solid #D8D8DC",
                    },
                    "& fieldset": {
                      borderColor: "transparent !important",
                    },
                  }}
                  value={info?.condition ?? "-"}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} sx={{ mt: { xs: 2, sm: 0 } }}>
              <Grid item xs={12} sx={{ mb: { xs: 0, sm: 1, md: 2 } }}>
                <Title primary>สรุปใบสั่งซื้อ</Title>
              </Grid>

              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Desc>ราคาสินค้า</Desc>
                <Desc>{`${convertIntToCurrency(
                  info?.totalPriceOfProduct ??
                    info?.productChoiceOrders
                      ?.map((product) => product.price * product.volume)
                      .reduce((a, b) => a + b),
                )} บาท`}</Desc>
              </Grid>

              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Grid item xs={6}>
                  <Desc>ราคาช่าง</Desc>
                  <TextSubTable>*ช่างประกอบและติดตั้ง</TextSubTable>
                </Grid>

                <Desc>{`${convertIntToCurrency(
                  info?.totalInstaller ??
                    info?.productChoiceOrders
                      ?.filter(
                        (product) =>
                          product?.installDetailGroup?.isService === true,
                      )
                      ?.map(
                        (product) =>
                          (product?.productChoiceOrder?.group_price
                            ?.install_price || 0) *
                            product?.installDetailGroup?.installArea +
                          product?.installDetailGroup?.sevicePrice,
                      )
                      .reduce((a, b) => a + b, 0),
                )} บาท`}</Desc>
              </Grid>

              {isAdmin && (
                <Grid container sm={12} lg={12} justifyContent="space-between">
                  <Desc>ส่วนลด</Desc>
                  <Desc>{`${convertIntToCurrency(info?.productChoiceOrders?.map((product) => product?.discount).reduce((a, b) => a + b, 0) || 0)} บาท`}</Desc>
                </Grid>
              )}

              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Grid item xs={6}>
                  <Desc>คูปองส่วนลด</Desc>
                  <TextSubTable>
                    {info?.discount?.promoCodeRef?.promoCode ?? "-"}
                  </TextSubTable>
                </Grid>
                <Desc>{`${convertIntToCurrency(info?.discount?.price ?? 0)} บาท`}</Desc>
              </Grid>

              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Desc>รวม</Desc>
                <Desc>{`${convertIntToCurrency(info?.totalPrice ?? 0)} บาท`}</Desc>
              </Grid>
              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Desc>ภาษี 7%</Desc>
                <Desc>{`${convertIntToCurrency(info?.vat ?? 0)} บาท`}</Desc>
              </Grid>
              <Grid container sm={12} lg={12} justifyContent="space-between">
                <Desc>ราคารวมทั้งหมด</Desc>
                <Desc>{`${
                  info?.statusPayment?.paymentType === "credit-card"
                    ? convertIntToCurrency(info?.totalAll * 1.03)
                    : convertIntToCurrency(
                        info?.statusPayment?.status === "deposit"
                          ? info?.totalAll
                            ? info?.totalAll
                            : info?.totalVat
                          : info?.totalVat,
                      )
                } บาท`}</Desc>
              </Grid>
            </Grid>
          </Grid>
        </Condition>
      )}

      {isAdmin && (
        <Payment>
          {info?.statusPayment?.status === "deposit" ? (
            <>
              <Grid container xs={12}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    borderRight: { xs: "none", sm: "1px solid #D8D8DC" },
                    borderBottom: { xs: "1px solid #D8D8DC", sm: "none" },
                    pr: { xs: 0, sm: 3 },
                    mb: { xs: 2, sm: 0 },
                    pb: { xs: 2, sm: 0 },
                  }}
                >
                  <Grid
                    container
                    xs={12}
                    justifyContent="space-between"
                    alignContent="center"
                  >
                    <Title>การชำระเงิน</Title>
                    {(info?.statusPayment?.paymentType === "promptpay" &&
                      info?.statusPayment?.paySlipImage) ||
                    (info?.statusPayment?.paymentType === "transfer" &&
                      info?.statusPayment?.paySlipImage) ? (
                      <Button
                        variant="outlined"
                        className="MuiButton-file"
                        startIcon={<VisibilityIcon />}
                        onClick={() =>
                          openDialog({
                            type: "custom",
                            customDialog: (
                              <PreviewSlip
                                onClose={() => closeDialog()}
                                img={info?.statusPayment?.paySlipImage?.docUrl}
                              />
                            ),
                          })
                        }
                      >
                        ดูหลักฐานการชำระเงิน
                      </Button>
                    ) : null}
                  </Grid>
                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>การชำระเงิน</Desc>
                    <Desc>
                      {info?.statusPayment?.status === "paid"
                        ? "เต็มจำนวน"
                        : "มัดจำ"}
                    </Desc>
                  </Grid>

                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>ช่องทางการชำระเงิน</Desc>
                    <Desc>{info?.statusPayment?.paymentType}</Desc>
                  </Grid>

                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>วันที่ชำระเงิน</Desc>
                    <Desc>
                      {dayjs(info?.statusPayment?.slipDate).format(
                        "DD-MM-YYYY HH:mm",
                      )}
                    </Desc>
                  </Grid>

                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>Ref Pay No.</Desc>
                    <Desc>{info?.statusPayment?.refPayNo}</Desc>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  // pl={3}
                  sx={{
                    xs: { borderRight: "none" },
                    sm: { borderRight: "1px solid #D8D8DC" },
                    pl: { xs: 0, sm: 3 },
                  }}
                >
                  <Grid
                    container
                    xs={12}
                    justifyContent="space-between"
                    alignContent="center"
                  >
                    <Title>การชำระเงิน</Title>
                    {(info?.statusPaymentRePay?.paymentType === "promptpay" &&
                      info?.statusPaymentRePay?.paySlipOtherImage) ||
                    (info?.statusPaymentRePay?.paymentType === "transfer" &&
                      info?.statusPaymentRePay?.paySlipOtherImage) ? (
                      <Button
                        variant="outlined"
                        className="MuiButton-file"
                        startIcon={<VisibilityIcon />}
                        onClick={() =>
                          openDialog({
                            type: "custom",
                            customDialog: (
                              <PreviewSlip
                                onClose={() => closeDialog()}
                                img={
                                  info?.statusPaymentRePay?.paySlipOtherImage
                                    ?.docUrl
                                }
                              />
                            ),
                          })
                        }
                      >
                        ดูหลักฐานการชำระเงิน
                      </Button>
                    ) : null}
                  </Grid>
                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>การชำระเงิน</Desc>
                    <Desc>
                      {info?.statusPaymentRePay?.status === "paid"
                        ? "เต็มจำนวน"
                        : "มัดจำ"}
                    </Desc>
                  </Grid>
                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>ช่องทางการชำระเงิน</Desc>
                    <Desc>{info?.statusPaymentRePay?.paymentType}</Desc>
                  </Grid>
                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>วันที่ชำระเงิน</Desc>
                    <Desc>
                      {dayjs(info?.statusPaymentRePay?.slipOtherDate).format(
                        "DD-MM-YYYY HH:mm",
                      )}
                    </Desc>
                  </Grid>
                  <Grid container xs={12} justifyContent="space-between" my={1}>
                    <Desc>Ref Pay No.</Desc>
                    <Desc>{info?.statusPaymentRePay?.refPayNo}</Desc>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                container
                xs={12}
                justifyContent="space-between"
                alignContent="center"
              >
                <Title>การชำระเงิน</Title>
                {(info?.statusPayment?.paymentType === "promptpay" &&
                  info?.statusPayment?.paySlipImage) ||
                (info?.statusPayment?.paymentType === "transfer" &&
                  info?.statusPayment?.paySlipImage) ? (
                  <Button
                    variant="outlined"
                    className="MuiButton-file"
                    startIcon={<VisibilityIcon />}
                    onClick={() =>
                      openDialog({
                        type: "custom",
                        customDialog: (
                          <PreviewSlip
                            onClose={() => closeDialog()}
                            img={info?.statusPayment?.paySlipImage?.docUrl}
                          />
                        ),
                      })
                    }
                  >
                    ดูหลักฐานการชำระเงิน
                  </Button>
                ) : null}
              </Grid>

              <Grid container xs={12} justifyContent="space-between" my={1}>
                <Desc>การชำระเงิน</Desc>
                <Desc>
                  {info?.statusPayment?.status === "paid"
                    ? "เต็มจำนวน"
                    : "มัดจำ"}
                </Desc>
              </Grid>

              <Grid container xs={12} justifyContent="space-between" my={1}>
                <Desc>ช่องทางการชำระเงิน</Desc>
                <Desc>{info?.statusPayment?.paymentType}</Desc>
              </Grid>

              <Grid container xs={12} justifyContent="space-between" my={1}>
                <Desc>วันที่ชำระเงิน</Desc>
                <Desc>
                  {dayjs(info?.statusPayment?.slipDate).format(
                    "DD-MM-YYYY HH:mm",
                  )}
                </Desc>
              </Grid>

              <Grid container xs={12} justifyContent="space-between" my={1}>
                <Desc>Ref Pay No.</Desc>
                <Desc>{info?.statusPayment?.refPayNo}</Desc>
              </Grid>
            </>
          )}
        </Payment>
      )}
    </Grid>
  );
};

export default PurchaseInfo;
